import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { SortableContext, horizontalListSortingStrategy } from "@dnd-kit/sortable";

import SortableItem from "./sortable_item";

const containerStyle = {
    border: "2px solid #dadada",
    borderWidth: 1,
    borderRadius: 5,
    padding: 10,
    margin: 10,
    flex: 1,
};

export default function Container(props) {
    const { id, items } = props;
    const { setNodeRef } = useDroppable({
        id
    });

    return (
        <SortableContext id={id} items={items} strategy={horizontalListSortingStrategy} >
            <div ref={setNodeRef} style={containerStyle}>
                {items.map((it) => (
                    <SortableItem key={it} id={it} type={id}/>
                ))}
            </div>
        </SortableContext>
    );
}
